import { HomeworkReportUIProvider } from "./HomeworkReportUIContext";
import { HomeworkReportCard } from "./HomeworkReportCard";

export function HomeworkReportPage() {
  return (
    <HomeworkReportUIProvider>
      <HomeworkReportCard />
    </HomeworkReportUIProvider>
 );
}